<template>
  <v-container fluid>
    <v-row align="center" class="mr-0">
      <h1>Campaign Info</h1>
      <v-spacer />
      <v-btn
        color="primary"
        @click="openNewDialog"
      >
        <v-icon left dark>add</v-icon>
        Add new
      </v-btn>
    </v-row>
    <v-layout>
      <v-flex xs3>
        <v-subheader>Candidate name:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          outline
          single-line
          hide-details
          :value="candidate_name"
          @change="setCandidateName"
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Campaign name:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          outline
          single-line
          hide-details
          :value="campaign_name"
          @change="setCampaignName"
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Website:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-text-field
          :value="website"
          @change="setWebsite"
          outline
          single-line
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Campaign type:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-select
          :value="campaign_type"
          :items="campaignTypes"
          @change="setCampaignType"
          item-text="name"
          item-value="value"
          single-line
          outline
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>State:</v-subheader>
      </v-flex>
      <v-flex xs6>
        <v-select
          :value="state"
          :items="states"
          @change="setState"
          item-text="name"
          single-line
          outline
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>District #:</v-subheader>
      </v-flex>
      <v-flex xs4>
        <v-text-field
          :value="district"
          @change="setDistrict"
          outline
          single-line
          hide-details
          class="select-bordered"
        />
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs3>
        <v-subheader>Campaign logo:</v-subheader>
      </v-flex>
      <v-flex xs4>
        <img v-if="reviewFileUrl" :src="reviewFileUrl" alt="Outfox AI" height="50px">
        <img v-else-if="selectedAdvertiser && selectedAdvertiser.data.logoLink" :src="selectedAdvertiser.data.logoLink" alt="Outfox AI" height="50px">
        <!-- <img v-else src="/static/img/lucyforcongress-logo-1853-620.png" alt="Outfox AI" height="50px"> -->
        <div class="input-file-block" v-ripple="{ class: 'white--text' }">
          <v-btn color="primary" class="ml-0">
            <v-icon
              left
              dark
              small
            >
              camera_alt
            </v-icon>
            Change Logo
          </v-btn>
          <input
            type="file"
            ref="file"
            @change="uploadLogo"
          />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import states from '../../../../static/states'
import campaignTypes from '../../../../static/campaign-types'
export default {
  name: 'AdminCampaignForm',
  data () {
    return {
      states: [],
      campaignTypes: []
    }
  },
  props: {
    candidate_name: {
      type: String,
      default: ''
    },
    campaign_name: {
      type: String,
      default: ''
    },
    website: {
      type: String,
      default: ''
    },
    campaign_type: {
      type: String,
      default: ''
    },
    state: {
      type: String,
      default: ''
    },
    district: {
      type: String,
      default: ''
    },
    reviewFileUrl: {
      type: String,
      default: ''
    },
    selectedAdvertiser: {
      type: Object,
      default: () => {}
    }
  },
  created () {
    this.states = states
    this.campaignTypes = campaignTypes
  },
  methods: {
    openNewDialog () {
      this.$router.push({name: 'NewAdvertiser'})
    },
    setCandidateName (value) {
      this.$emit('setField', 'candidate_name', value)
    },
    setCampaignName (value) {
      this.$emit('setField', 'campaign_name', value)
    },
    setWebsite (value) {
      this.$emit('setField', 'website', value)
    },
    setCampaignType (value) {
      this.$emit('setField', 'campaign_type', value)
    },
    setState (value) {
      this.$emit('setField', 'state', value)
    },
    setDistrict (value) {
      this.$emit('setField', 'district', value)
    },
    uploadLogo () {
      const file = this.$refs.file.files[0]
      if (!file) {
        this.showNotification({
          type: 'warning',
          message: ['Please add a file']
        })
        return false
      }
      let allowFileTypes = ['image/gif', 'image/png', 'image/jpg', 'image/jpeg']
      if (!allowFileTypes.find(type => type === file.type)) {
        this.showNotification({
          type: 'warning',
          message: ['Next file types allowed: gif, png, jpg, jpeg']
        })
        return false
      }
      const reviewFileUrl = URL.createObjectURL(file)
      this.$emit('updateLogo', reviewFileUrl, file)
    }
  }
}
</script>
